// LocationArea.js
import { computed, defineComponent } from "/Scripts/vue.esm-browser.js";
import {
  convertToChineseFormatNative,
  getTextWithoutSign,
} from "/Scripts/tools.js";
import CardWrap from "/Component/Promotions/Keyword/product/CardWrap.js";

const html = String.raw;
export default defineComponent({
  name: "LocationArea",
  components: {
    CardWrap,
  },
  props: {
    area: {
      type: String,
      required: true,
    },
    openDate: {
      type: [String, Number],
    },
    items: {
      type: Array,
      default: () => [],
    },
    isFilterOpen: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    promotion: {
      type: String,
    },
    promotionData: {
      type: Object,
    },
    subAreaName: {
      type: String,
    },
    subAreas: {
      type: Array,
      default: () => [],
    },
  },
  inject: ["groupShowType"],
  emits: [],
  setup(props, { emit }) {
    const isSpecial = !!props.promotion;
    const displaySubAreas = computed(() => {
      if (props.subAreas.length > 0) return props.subAreas;
      return [
        {
          subAreaName: props.subAreaName || "",
          items: props.items,
        },
      ];
    });
    const firstItem = computed(() => displaySubAreas.value[0]?.items?.[0]);
    return {
      convertToChineseFormatNative,
      getTextWithoutSign,
      isSpecial,
      displaySubAreas,
      firstItem,
    };
  },
  template: html`
    <div
      class="location_area"
      :class="{'loading':isLoading,'is-special':isSpecial}"
      :data-area-name="getTextWithoutSign(area)"
      :data-location-name="getTextWithoutSign(promotion||area)"
    >
      <!-- 地點大標  -->
      <div class="location_title" v-if="area">
        <template v-if="!isSpecial">
          <picture>
            <source
              media="(max-width: 768px)"
              :srcset="'/action/theme/clearanceSale/V2/images/title/'+area+'-m.webp'"
            />
            <img
              loading="lazy"
              :src="'/action/theme/clearanceSale/V2/images/title/'+area+'-pc.webp'"
              alt=""
            />
          </picture>
          <div class="location_title-map">
            <img
              loading="lazy"
              :src="'/action/theme/clearanceSale/V2/images/title/'+area+'-map.webp'"
              alt=""
            />
          </div>
        </template>
        <template v-else>
          <picture>
            <source
              media="(max-width: 768px)"
              :srcset="'/action/theme/clearanceSale/V2/images/title/'+firstItem?.promotion?.title+'-m.webp'"
              :alt="firstItem?.promotion?.title"
            />
            <img
              loading="lazy"
              :src="'/action/theme/clearanceSale/V2/images/title/'+firstItem?.promotion?.title+'-pc.webp'"
              :alt="firstItem?.promotion?.title"
            />
          </picture>
        </template>
      </div>

      <!-- 依主題為區塊  -->
      <card-wrap
        v-for="subArea in displaySubAreas"
        :key="subArea.subAreaName || 'default-subArea'"
        :items="subArea.items"
        :sub-area-name="subArea.subAreaName"
        :isFilterOpen="isFilterOpen"
        :is-loading="isLoading"
      ></card-wrap>
    </div>
  `,
  methods: {},
});
